import { type IFile } from '../../types'
import { ACCESS_KEY, REACT_APP_BASE_URL, USER_ID_KEY } from '../../urls'
import { nanoid } from 'nanoid'
import _ from 'lodash'
import { endpoints, urlV2 } from '../../functions/shared/api/apiConfig';

const isDigits = (v: unknown): v is string =>
    typeof v === 'string' && /^\d+$/.test(v);

type Collection = 'users' | 'units' | 'documents' | 'chat-rooms' | string;

const inferFieldName = (collection: Collection, file: File): string => {
    const lower = file.name.toLowerCase();
    const mimeGroup = file.type.split('/')[0]; 

    if (collection === 'documents') {
        if (lower.includes('back')) return 'LinkBack';
        if (lower.includes('front')) return 'LinkFront';
        return 'Document';
    }
    if (collection === 'users') return 'Photo';
    if (collection === 'units') {
        const isPlan = file.type === 'application/pdf' || /plan|layout|scheme/.test(lower);
        if (isPlan) return 'Plan';
        if (mimeGroup === 'image') return 'Image';
        if (mimeGroup === 'video') return 'Video';
        return 'File';
    }
    if (collection === 'chat-rooms') {
        if (mimeGroup === 'audio') return 'Voice';
        if (mimeGroup === 'image') return 'Image';
        if (mimeGroup === 'video') return 'Video';
        return 'File';
    }
    return 'File';
};



export const uploadStrapiFile = async (
    file: File,
    collection = 'users',
    entityID: string | null = null,
    fieldName?: string
): Promise<IFile | null> => {

    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? '';
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? '';

    const entryId =
    (entityID != null && isDigits(entityID) ? entityID : null) ??
    (isDigits(userID) ? userID : null);

    const resolvedField =  inferFieldName(collection, file);

    if (entryId == null || resolvedField == null) {
        console.warn('uploadStrapiFileV2: cannot resolve entryId or fieldName', {
            collection,
            entityID,
            resolvedField,
            userID
        });
        return null;
    }

    const form = new FormData();
    form.append('file', file);
    form.append('contentType', collection );
    form.append('entryId', String(entryId ?? userID));
    form.append('fieldName', `Admin-${resolvedField}`);

    try {
        const res = await fetch(`${urlV2}${endpoints.main.uploadFile}`, {
            method: 'POST',
            body: form,
            headers: { Authorization: `Bearer ${jwt}` }
        });

        const json = await res.json().catch(() => ({} as any));
        if (!res.ok) {
            console.error('uploadStrapiFileV2 error response', { status: res.status, json });
            return null;
        }

        const link =   json?.data?.url ??  json?.data?.link ?? json?.url ??
      json?.link ??
      json?.response?.link ??
      null;

console.log({
            data: link,
            name: file.name,
            type: file.type,
            size: file.size
        })

        return {
            data: link,
            name: file.name,
            type: file.type,
            size: file.size
        };
    } catch (e) {
        console.error('uploadStrapiFileV2 exception', e);
        return null;
    }
};








export const uploadMultipleFiles = async (files: FileList | null, collection: string, entityID: string | null = null, refID: string | null = null): Promise<Array<IFile | null>> => {
    const promises = _.map(files, async (file) => await uploadStrapiFile(file, collection, entityID)) // , refID
    return await Promise.all(promises)
}

const downloadBlobAsFile = (blob: Blob, type: any): void => {
    // Create a link element
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = 'test-file.mp3' // Replace with the desired file name
    downloadLink.style.display = 'none' // Hide the link

    // Append the link to the document body
    document.body.appendChild(downloadLink)

    // Trigger the download by simulating a click event on the link
    downloadLink.click()

    // Clean up by removing the link from the document body
    document.body.removeChild(downloadLink)
}

export const transcodeVoiceMessage = async (recordingBlob: Blob): Promise<Blob | null> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    const file = new File([recordingBlob], `voice-${nanoid(10)}.webm`, {
        type: 'audio/webm'
    })

    const formData = new FormData()
    formData.append('file', file)
    try {
        const response = await fetch(`${REACT_APP_BASE_URL}/api/app/convertVoiceMessage`, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        })
        return await response.blob()
    } catch (error) {
        console.error(error, 'error')
        return null
    }
    // const uploadedFile = await uploadStrapiFile(file, 'chat-rooms')
}

export const transcodeImage = async (file: File): Promise<File | null> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    const formData = new FormData()
    formData.append('file', file)
    try {
        const response = await fetch(`${REACT_APP_BASE_URL}/api/app/convertImage`, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        })
        const blob = await response.blob()
        return new File([blob], String(_.slice(file.name, 0, _.lastIndexOf(file.name, '.'))) + '.jpeg', {
            type: 'image/jpeg'
        })
    } catch (error) {
        console.error(error, 'error')
        return null
    }
}
